import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss']
})
export class TermsAndConditionsComponent implements OnInit {

  @ViewChild("paymentTerms") paymentTerms: ElementRef;

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    if (this.route.snapshot.queryParams['terms']) {
      setTimeout(() => {
        this.paymentTerms.nativeElement.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 100);
    }
  }

  openEmailClient(): void {
    // Ensure the mailto link opens properly
    window.location.href = 'mailto:support@evaltrix.com';
  }

}
